import { Community } from "@sp-crm/core";
import { PrimaryButton } from "components/ui/primary-button";
import { HomePlusIcon } from "components/ui/home-plus-icon";

import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveNewCommunity } from "store/actions";
import { ApplicationState } from "store/state";

export const AddNewCommunityButton = () => {
    const newCommunityRegion = useSelector(
        (state: ApplicationState) => state.region.selectedRegion,
    );
    const dispatch = useDispatch();
    const createCommunity = useCallback(() => {
        return saveNewCommunity(
            {
                name: "",
                regions: [newCommunityRegion],
            } as unknown as Community,
            dispatch,
        );
    }, [dispatch, newCommunityRegion]);

    return (
        <PrimaryButton onClick={createCommunity}>
            <div className="flex items-center space-x-2">
                <HomePlusIcon className="w-5 h-5" />
                <span className="text-sm">New Community</span>
            </div>
        </PrimaryButton>
    );
};
